











































import { computed, defineComponent } from '@vue/composition-api';
import { useFieldsView } from '@/store/modules/fieldsView';
import { useGroups } from '@/store/modules/group';

export default defineComponent({
	emits: ['ok'],
	props: {
		useDesktopLayout: {
			type: Boolean,
			default: false,
		},
	},
	setup(_, { root }) {
		const { groupTree } = useGroups(root.$store);
		const { groupFilter, setGroupFilter } = useFieldsView(root.$store);
		const openedGroupIds = computed(() => root.$store.getters['fieldsView/getOpenedGroupIds']);

		const isChecked = (id: string) => groupFilter.value.includes(id);

		const treeViewClass = computed<string>(() => {
			const childrenCount = groupTree.value.reduce((prev, cur) => prev + cur.children.length, 0);
			return childrenCount === 0 ? 'no-children' : '';
		});

		const handleOpenChange = (value: string[]) => {
			root.$store.dispatch('fieldsView/setOpenedGroupIds', value);
		};

		const toggleCheck = (id: string) => {
			setGroupFilter(id);
		};

		const clearFilter = () => {
			// Uncheck all nodes
			root.$store.dispatch('fieldsView/clearGroupFilter');
			// Collapse group tree
			root.$store.dispatch('fieldsView/setOpenedGroupIds', []);
		};

		return {
			treeViewClass,
			groupTree,
			openedGroupIds,
			isChecked,
			toggleCheck,
			handleOpenChange,
			clearFilter,
		};
	},
});
